export const colorPalettes = [
    {
        id: 'blues',
        label: 'Blues',
        colors: ['#eff3ff', '#bdd7e7', '#6baed6', '#3182bd', '#08519c'],
    },
    {
        id: 'ylOrRd',
        label: 'YlOrRd',
        colors: ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026'],
    },
    {
        id: 'reds',
        label: 'Reds',
        colors: ['#fee5d9', '#fcae91', '#fb6a4a', '#de2d26', '#a50f15'],
    },
    {
        id: 'ylGnBu',
        label: 'YlGnBu',
        colors: ['#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#225ea8'],
    },

    {
        id: 'rdBu',
        label: 'RdBu',
        colors: ['#b2182b', '#ef8a62', '#f7f7f7', '#67a9cf', '#2166ac'],
    },
    {
        id: 'brBg',
        label: 'BrBG',
        colors: ['#8c510a', '#d8b365', '#f5f5f5', '#5ab4ac', '#01665e'],
    },

    {
        id: 'set1',
        label: 'Set1',
        colors: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00'],
    },
    {
        id: 'set2',
        label: 'Set2',
        colors: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854'],
    },
    {
        id: 'dark2',
        label: 'Dark2',
        colors: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e'],
    },
];

export const classificationMethods = [
    { id: 'equal', label: '동일 구간' },
    { id: 'quantile', label: '분위수' },
    { id: 'custom', label: '사용자 지정' },
];

export const geometryLabelMap = {
    point: '포인트',
    line: '라인',
    polygon: '폴리곤',
};

export const GEOMETRY_ORDER = ['point', 'line', 'polygon'];

export const geometryIconClassMap = {
    point: 'fg fg-layer-poi',
    line: 'fg fg-layer-road',
    polygon: 'fg fg-layer-contour',
};

export const paletteValueSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    width: '100%',
};

export const paletteSwatchSx = {
    display: 'flex',
    gap: 0.5,
    flex: 1,
    maxWidth: 150,
};

export const paletteChipSx = {
    flex: 1,
    height: 16,
    borderRadius: 0.5,
    border: '1px solid rgba(17,24,39,0.08)',
};